<script lang="ts">
	import { onMount } from "svelte"
	import type { ContextMenuConfig } from "./ContextMenuTypes"

	let ctxMenuRef: HTMLDivElement = $state()
	let pos = $state({
		x: 0,
		y: 0,
	})

	interface Props {
		closeCtxMenu: () => void
		parentBtnAmount: number
		parentMenuRect: DOMRect
		parentButtonRect: DOMRect
		config: ContextMenuConfig
	}

	let {
		closeCtxMenu,
		parentBtnAmount,
		parentMenuRect,
		parentButtonRect,
		config,
	}: Props = $props()

	let buttonRefs: Array<HTMLButtonElement> = $state([])
	let hasTabbed = $state(false)
	let opacityAmt = $state(0)

	function initTab() {
		hasTabbed = true
		setTimeout(() => {
			buttonRefs[0].focus()
		})
	}

	function updatePosition() {
		hasTabbed = false
		pos.x = parentMenuRect.right
		pos.y = parentButtonRect.top - convertRemToPixels(0.5)
	}

	function convertRemToPixels(rem: number) {
		return rem * parseFloat(getComputedStyle(document.documentElement).fontSize)
	}

	/**
	 * Restricts the position of the context menu to within the window
	 */
	function restrictCtxMenuToWindow() {
		const { right, bottom } = ctxMenuRef.getBoundingClientRect()
		if (right > window.innerWidth) {
			pos.x = pos.x - (right - window.innerWidth + 8)
			console.log({ pos, parentMenuRect })
			if (pos.x >= parentMenuRect.left && pos.x <= parentMenuRect.right) {
				pos.x = parentMenuRect.left - convertRemToPixels(12)
			}
		}
		if (bottom > window.innerHeight) {
			pos.y = pos.y - (bottom - window.innerHeight + 8)
		}

		if (pos.x < 0) {
			pos.x = 0 + 8
		}
	}

	onMount(() => {
		if (config.isOpen) {
			updatePosition()
			setTimeout(() => {
				opacityAmt = 100
				restrictCtxMenuToWindow()
			})
		}
	})
</script>

{#if config.isOpen}
	<div
		bind:this={ctxMenuRef}
		class="ctxMenu"
		style={`
			opacity: ${opacityAmt}%;
			left: ${pos.x}px;
			top: ${pos.y}px;
			`}
	>
		{#each config.options as option, i}
			<button
				tabindex={parentBtnAmount + i}
				bind:this={buttonRefs[i]}
				onclick={(e) => {
					if ("hasSubmenu" in option) {
						throw new Error("Submenu cannot have another submenu.")
					} else {
						closeCtxMenu()
						if ("onClick" in option) option.onClick(e)
					}
				}}
				style={"style" in option ? option.style : ""}
				class="icon ctxMenuOpt"
				>{"title" in option ? option.title : ""}
			</button>
		{/each}
	</div>
{/if}
<svelte:window
	onkeydown={(e) => {
		if (e.key === "Tab" && config.isOpen && !hasTabbed) initTab()
	}}
/>

<style>
	.ctxMenu {
		transition:
			left 50ms,
			right 50ms,
			opacity var(--transition-duration);
	}
</style>
